import React from 'react';
import PropTypes from 'prop-types';
import ThemeToggle from '../AppShell/ThemeToggle';
import '../AppShell/TopBar.css';
import './PublicV2.css';

/**
 * The logged-out top bar in the new design: the app's v2 top bar look
 * (mist ground, official wordmark, byline) so the landing page, the sign-in
 * and the app read as one product. The wordmark is the client artwork 1:1;
 * in dark it sits on the same light plate as in the app (theme.css). The
 * theme menu is the app's own (config/theme.js); the landing page places
 * it itself, between Help and Sign in (showTheme={false} here).
 */
export default function PublicTopBar({ children, showTheme = true }) {
    return (
        <header className="pub2-topbar">
            <div className="pub2-brand">
                <img
                    className="pub2-wordmark"
                    src="/ironsight-wordmark.png"
                    alt="IronSight"
                    width="81"
                    height="22"
                />
                <span className="pub2-by">by Fusable</span>
            </div>
            <span className="pub2-spacer" />
            {showTheme && <ThemeToggle />}
            {children}
        </header>
    );
}
PublicTopBar.propTypes = { children: PropTypes.node, showTheme: PropTypes.bool };

// No Privacy / Terms / Support links: the app has no such pages yet.
export function PublicFooter() {
    return (
        <footer className="pub2-footer">
            <span>IronSight by Fusable · © {new Date().getFullYear()} Fusable</span>
        </footer>
    );
}
